import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthBoundary } from './auth/AuthBoundary'
import { startProfilerIfRequested } from './lib/profiler'
// @grovus/design-system's Vite library build extracts its CSS to a separate asset
// instead of an auto-loaded JS import (a Vite library-mode limitation), so the
// package exposes it as this explicit subpath for consumers to import themselves.
import '@grovus/design-system/styles.css'
import './styles/app.css'
import './styles/shell.css'

// Before the first render, so a reload's first mount is inside the trace (lib/profiler.ts).
startProfilerIfRequested(window, localStorage)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthBoundary />
  </StrictMode>,
)
